module.exports = __webpack_public_path__ + "14_scivis.png?ce3c8ca5ecb56a7e3461fce026482cea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/14_scivis.png
// module id = 155
// module chunks = 0